<template>
  <div class="container tenant-customize">
    <TenantProfileMenu />

    <div class="grey-box-container">
      <h2>Company Customization</h2>

      <form ref="tenantForm">

        <div class="clearfix">

          <div class="col12">
            <fieldset>
              <label>Company Logo</label><br/>
              <small>Note: Should be square for optimal layout and the suggested size should be at least 200x200px.</small>
            </fieldset>
            <fieldset v-if="hasLogo">
              <div>
                <img :src="tenantData.logoUrl" class="company-logo" style="float:left; margin-right: .5rem;"/>
                <button class="btn-neutral-light btn-small" @click.prevent="removeLogo">Remove logo</button>
              </div>
            </fieldset>
            <fieldset v-else>
              <div>
                <croppa v-model="croppaLogo"
                        :width="100"
                        :height="100"
                        :canvas-color="'transparent'"
                        :placeholder="'Upload'"
                        :placeholder-font-size="14"
                        :placeholder-color="'#666'"
                        :accept="'image/*'"
                        :file-size-limit="10240000"
                        :quality="2"
                        :zoom-speed="15"
                        :disabled="false"
                        :disable-drag-and-drop="false"
                        :disable-click-to-choose="false"
                        :disable-drag-to-move="false"
                        :disable-scroll-to-zoom="false"
                        :disable-rotation="true"
                        :prevent-white-space="false"
                        :reverse-scroll-to-zoom="false"
                        :show-remove-button="true"
                        :remove-button-color="'grey'"
                        :remove-button-size="32"
                        :initial-size="'contain'"
                        @init="handleCroppaInit"
                        @file-choose="handleCroppaFileChoose"
                        @file-size-exceed="handleCroppaFileSizeExceed"
                        @file-type-mismatch="handleCroppaFileTypeMismatch"
                        @image-remove="handleImageRemove"
                        @move="handleCroppaMove"
                        @zoom="handleCroppaZoom">
                </croppa>
              </div>
            </fieldset>
            <fieldset>
              
            </fieldset>
            <fieldset>
              <label for="extLogoUrl">External Company Logo URL (Optional)</label><br/>
              <small>Note: The Company Logo should be square for optimal layout and the suggested size should be at least 200x200px. If the External Company Logo URL is used, it overrides the uploaded Company Logo.</small>
              <input v-model.trim="tenantData.extLogoUrl" id="extLogoUrl" type="text" placeholder="e.g. http://company.com/logo.jpg" />
            </fieldset>
            <fieldset v-if="tenantData.extLogoUrl">
              <div><img :src="tenantData.extLogoUrl" class="company-logo" /></div>
            </fieldset>
          </div>

          <div class="col12">
            <fieldset>
              <label>Brand Accent Color</label><br/>
              <small>This color will be used for accents and button colors.</small>
              <div class="clearfix" style="margin-top: 1rem; position: relative;">
                <div class="brand-color-example" :style="{ backgroundColor: brandColorModel.hex }" @click="colorPickerVisible = !colorPickerVisible"></div>
                <div style="position: absolute; display: inline-block;" v-if="colorPickerVisible">
                  <ColorPicker v-if="brandColorModel.hex" v-model="brandColorModel" :disableAlpha="true" :disableFields="false" @input="updateBrandColor" />
                </div>
              </div>
            </fieldset>
          </div>

        </div>

        <fieldset>
          <label>Banner Image</label><br/>
          <small>Note: </small><br/>
          <small>The Banner Image should be rectangle for optimal layout and the suggested size should be at least 1200x300px.</small><br/>
          <small>Image will be darkened for legibility and is previewed here in smaller size.</small>
        </fieldset>

        <fieldset v-if="hasBanner">
          <div><img :src="tenantData.bannerUrl" class="company-banner" /></div>
          <div>
            <v-switch :label="`Show banner overlay`" v-model="tenantData.showBannerOverlay"></v-switch>
          </div>
          <div><button class="btn-neutral-light btn-small" @click.prevent="removeBanner">Remove banner</button></div>
        </fieldset>
        <fieldset v-else>
          <div>
            <croppa v-model="croppaBanner"
                    :width="720"
                    :height="140"
                    :canvas-color="'#eee'"
                    :placeholder="'Upload'"
                    :placeholder-font-size="14"
                    :placeholder-color="'#666'"
                    :accept="'image/*'"
                    :file-size-limit="10240000"
                    :quality="2"
                    :zoom-speed="10"
                    :disabled="false"
                    :disable-drag-and-drop="false"
                    :disable-click-to-choose="false"
                    :disable-drag-to-move="false"
                    :disable-scroll-to-zoom="false"
                    :disable-rotation="true"
                    :prevent-white-space="true"
                    :reverse-scroll-to-zoom="false"
                    :show-remove-button="true"
                    :remove-button-color="'grey'"
                    :remove-button-size="32"
                    :initial-size="'cover'"
                    @init="handleCroppaInit"
                    @file-choose="handleCroppaFileChoose"
                    @file-size-exceed="handleCroppaFileSizeExceed"
                    @file-type-mismatch="handleCroppaFileTypeMismatch"
                    @image-remove="handleImageRemove"
                    @move="handleCroppaMove"
                    @zoom="handleCroppaZoom">
            </croppa>
          </div>
          <div>
            <v-switch :label="`Show banner overlay`" v-model="tenantData.showBannerOverlay"></v-switch>
          </div>
        </fieldset>
        <fieldset class="align-right">
          <button class="wider" @click.prevent="update">Update customization</button>
        </fieldset>

      </form>

    </div>
  </div>
</template>

<script>
  import TenantProfileMenu from './TenantProfileMenu.vue'
  import { Sketch as ColorPicker } from 'vue-color'

  export default {
    name: 'TenantCustomize',
    components: {
      TenantProfileMenu,
      ColorPicker
    },
    data() {
      return {
        croppaLogo: {},
        croppaBanner: {},
        saved: false,
        tenantData: {
          logoUrl: '', // for reading logo during GET
          logoData: null,  // for updating logo during POST
          extLogoUrl: '',
          bannerUrl: '', // for reading banner during GET
          bannerData: null, // for updating banner during POST
          showBannerOverlay: true,
          brandColor: '',
          logo: '',
          banner: '',
          removeLogo: false,
          removeBanner: false
        },
        logoData: {
          filename: '',
          dataUri: ''
        },
        colorPickerVisible: false,
        brandColorModel: {
          hex: ''
        }
      }
    },
    computed: {
      hasLogo() {
        if ( this.tenantData.logo.key === 'null' ) {
          return false
        } else {
          return this.tenantData.logoUrl && this.tenantData.logoUrl.length > 0
        }
      },
      hasBanner() {
        if ( this.tenantData.banner.key === 'null' ) {
          return false
        }
        return this.tenantData.bannerUrl && this.tenantData.bannerUrl.length > 0
      }
    },
    created() {
      // Fetch data which is already stored
      this.$store.commit('setLoadingSpinner', true)
      this.$PfxBackendApi.getTenantData()
        .then(res => {
          console.log('getTenantData res', res)
          this.tenantData = res.data
          //the next 2 lines are used to mange if the logo and/or banner should be removed
          this.tenantData.removeLogo = false
          this.tenantData.removeBanner = false

          if (!this.tenantData.brandColor) this.tenantData.brandColor =  '#E02020'
          this.brandColorModel.hex = this.tenantData.brandColor
        })
        .catch(err => {
          console.error('getTenantData err', err)
          if (err.status === 404) {
            this.tenantData = {
              subdomain: this.$store.state.tenant.subdomain
            }
          }
        })
        .then(() => {
          this.$store.commit('setLoadingSpinner', false)
        })
    },
    methods: {
      update() {
        if (!this.$refs.tenantForm.checkValidity()) {
          this.$refs.tenantForm.reportValidity()
          return
        }
        this.$store.commit('setLoadingSpinner', true)

        const submit = {...this.tenantData}
        delete submit.logo
        delete submit.logoUrl
        if (this.croppaLogo.hasImage && this.croppaLogo.hasImage()) {
          submit.logoData = {
            dataUri: this.croppaLogo.generateDataUrl('image/png', 0.8),
            filename: this.tenantData.subdomain + '-' + new Date().getTime() + '-tenant-logo.png'
          }
          submit.removeLogo = false
        }
        delete submit.banner
        delete submit.bannerUrl
        if (this.croppaBanner.hasImage && this.croppaBanner.hasImage()) {
          submit.bannerData = {
            dataUri: this.croppaBanner.generateDataUrl('image/png', 0.8),
            filename: this.tenantData.subdomain + '-' + new Date().getTime() + '-tenant-banner.png'
          }
          submit.removeBanner = false
        }

        this.$PfxBackendApi
          .updateTenant(submit)
          .then((res) => {
            console.log('updateTenant res', res)
            this.saved = true
            this.refetchTenantData()
            this.$vuetify.theme.brand = this.tenantData.brandColor
            this.$store.commit('setBrandColor', this.tenantData.brandColor)
            this.$notify({ type: 'info', message: 'Company profile stored' })
          })
          .catch(err => {
            console.error('updateTenant err', err)
            this.$notify({ type: 'danger', message: 'Cannot store company profile' })
          })
          .then(() => {
            this.$store.commit('setLoadingSpinner', false)
          })
      },

      removeLogo() {
        this.tenantData.logoUrl = ''
        this.tenantData.logoData = null
        this.tenantData.removeLogo = true
        // this.logoData.dataUri = ''
        // this.logoData.filename = ''
      },
      removeBanner() {
        this.tenantData.bannerUrl = ''
        this.tenantData.bannerData = null
        this.tenantData.removeBanner = true
        // this.bannerData.dataUri = ''
        // this.bannerData.filename = ''
      },

      handleCroppaInit() {},
      handleCroppaFileChoose() {},
      handleCroppaFileSizeExceed() {
        this.$store.commit('openDialog', 'Image file size was too big. Maximum file size is 10MB.')
      },
      handleCroppaFileTypeMismatch() {
        this.$store.commit('openDialog', 'File type was not an image.')
      },
      handleImageRemove() {},
      handleCroppaMove() {},
      handleCroppaZoom() {},

      updateBrandColor(value) {
        this.tenantData.brandColor = value.hex
      },

      refetchTenantData() {
        const subdomain = this.$store.state.tenant.subdomain
        this.$PfxBackendApi.getTenantPublic(subdomain).then(res => {
          console.log('getTenantPublic', res)
          this.$store.commit('setTenant', { subdomain: subdomain, status: this.$store.state.tenant.status, data: res.data })
        }).catch(err => {
          console.error('getTenantPublic err', err)
        })
      }

    }
  }
</script>

<style lang="scss" scoped>

  @import '../pfx.scss';

  .col12 { @include column(1/2); }

  h2 {
    margin: 0 0 1rem 0;
  }

  label {
    font-weight: 600;
  }

  .company-logo {
    width: 6rem;
    height: 6rem;
  }

  .company-banner {
    width: 100%;
  }

  .brand-color-example {
    display: inline-block;
    cursor: pointer;
    margin-right: 1rem;
    width: 4rem;
    height: 4rem;
    //float: left;
    outline: 1px solid #ccc;
    border: .5rem solid #fff;
  }

</style>



// WEBPACK FOOTER //
// src/components/TenantCustomize.vue